import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react'

import { useSettings } from '../slices/settings'
import { getScrollableParent } from '../utils'

import {
  SHOW_MORE,
  SHOW_LESS
} from "../trans"

const Readmore = (props) => {
  const {maxHeight, children} = props
  const content = useRef()
  const parentScroll = useRef()
  const { zoom } = useSettings()
  const [hasMore, setHasMore] = useState(false)
  const [collapsed, setCollapsed] = useState(true)

  const style = useMemo(() => {
    if (!collapsed || !hasMore) return
    return {
      maxHeight: `${maxHeight * zoom}px`,
      overflow: 'hidden'
    }
  }, [maxHeight, collapsed, hasMore, zoom])

  const className = useMemo(() => {
    if (hasMore && collapsed) {
      return 'pwa__readmore collapsed'
    } else {
      return 'pwa__readmore'
    }
  }, [hasMore, collapsed])

  useEffect(() => {
    const scrollHeight = content.current.scrollHeight
    setHasMore(scrollHeight > (maxHeight * zoom * 1.3))
  }, [maxHeight, zoom, children])

  useEffect(() => {
    if (collapsed && parentScroll.current) {
      const {parent, scrollTop} = parentScroll.current
      if (parent) parent.scrollTop = scrollTop
      parentScroll.current = null
    }
  }, [collapsed])

  const onClick = () => {
    if (collapsed) {
      const parent = getScrollableParent(content.current)
      const scrollTop = parent?.scrollTop
      parentScroll.current = {
        parent: parent, 
        scrollTop:scrollTop
      }
    }
    setCollapsed(!collapsed)
  }

  return (
    <div className={className}>
      <div ref={ content } style={style} className="content">
        { children }
      </div>
      { hasMore && (
        <button className="pwa__readmore__button button" onClick={ onClick }>
          { collapsed ? SHOW_MORE : SHOW_LESS }
        </button>
      )}
    </div>
  )
}

export default Readmore
